import { Theme } from '@astryxdesign/core/theme';
import { InternationalizationProvider } from '@astryxdesign/core/i18n';
import { LinkProvider } from '@astryxdesign/core/Link';
import ruRU from '@astryxdesign/core/locales/ru-RU.generated.js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router';
import { ApiError } from '@shared/errors.ts';
import { baseLightTheme, baseTheme } from '@/lib/theme.ts';
import { shellMode } from '@/lib/industry.ts';
import { RouterLink } from './RouterLink.tsx';
import { TenantRoot } from './TenantRoot.tsx';
import { NoTenantPage } from './NoTenantPage.tsx';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (count, e) => !(e instanceof ApiError && e.status < 500 && e.status !== 429) && count < 2,
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
});

export function App() {
  return (
    <InternationalizationProvider locale="ru-RU" messages={{ 'ru-RU': ruRU }}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <LinkProvider component={RouterLink}>
            <Routes>
              <Route path="/s/:slug/*" element={<TenantRoot />} />
              <Route
                path="*"
                element={
                  <Theme theme={shellMode() === 'light' ? baseLightTheme : baseTheme} mode={shellMode()}>
                    <NoTenantPage />
                  </Theme>
                }
              />
            </Routes>
          </LinkProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </InternationalizationProvider>
  );
}
